// #useAuthUpdated

import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DatabaseProvider from "../contexts/DatabaseContext";
import { useAuth } from "../contexts/AuthContext";
import PublicRoutes from "./routes/PublicRoutes";
import { companies } from "../mui/themes";
import DealerMenu from "./DealerMenu";
import { CompanyProvider } from "../contexts/CompanyContext";
import { StructureProvider } from "../contexts/StructureContext";
// import { NotificationProvider } from "../contexts/NotificationContext";
import SupabaseProvider from "../contexts/SupabaseContext";
import MainMenu from "./MainMenu";
import { UserProvider } from "../features/users";

/**
 * This is the top-level component of the app. It is responsible for wrapping
 * the entire app with the necessary Material-UI and React Router components.
 * It also checks if a user is logged in and if so, determines whether to show
 * the main menu or the dealer menu.
 *
 * @returns A BrowserRouter component wrapping the app.
 */
export default function Wrapper() {
  const { currentUser } = useAuth();
  const company = companies.zawadi;

  // <NotificationProvider>
  //   {currentUser.is_admin ? <MainMenu /> : <DealerMenu logo={company.logo} />}
  // </NotificationProvider>;

  return (
    <BrowserRouter>
      <ThemeProvider theme={company.theme}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          {currentUser && currentUser.id ? (
            <SupabaseProvider>
              <DatabaseProvider companyId={currentUser.companyId}>
                <CompanyProvider>
                  <UserProvider>
                    <StructureProvider>
                      {currentUser.is_admin ? (
                        <MainMenu />
                      ) : (
                        <DealerMenu logo={company.logo} />
                      )}
                    </StructureProvider>
                  </UserProvider>
                </CompanyProvider>
              </DatabaseProvider>
            </SupabaseProvider>
          ) : (
            <PublicRoutes logo={company.logo} />
          )}
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
